export default {"src":"/_next/static/image/public/assets/coin.68081a5ef7c9fd526695bd6d3aae8785.svg","height":41,"width":41};